import React, { Component } from 'react';

class AssignableEventsTable extends Component {
  constructor(props) {
    super(props);

    this.renderEvent = this.renderEvent.bind(this);
    this.renderEmptyState = this.renderEmptyState.bind(this);
  }

  render() {
    const { events, loading } = this.props;

    if (loading) {
      return <div>Loading...</div>;
    }

    return (
      <>
        {this.props.displayTitle && (
          <h3 className="inline-block">Assignable Events:</h3>
        )}

        <div className="scrollable-table center bottom-margin">
          <table className="checkbox-table">
            <thead className="heading">
              <tr className="tr">
                <th className="th">Person</th>
                <th className="th">Arrived</th>
                <th className="th">Left</th>
                <th className="th">{this.props.assignmentHeader}</th>
              </tr>
            </thead>

            <tbody>
              {events.map((assignable_event) => (
                this.renderEvent(assignable_event)
              ))}
            </tbody>
          </table>

        {this.renderEmptyState()}
        </div>
      </>
    );
  }

  renderEvent(assignable_event) {
    const { selectedEventIds, onChange } = this.props;

    return (
      <tr className="tr" key={assignable_event.id}>
        <td className="td">{assignable_event.person_name}</td>
        <td className="td">{assignable_event.check_in}</td>
        <td className="td">{assignable_event.check_out}</td>
        <td className="td center-cell">
          <input className="column" type="checkbox" name={assignable_event.id} checked={selectedEventIds.includes(assignable_event.id)} disabled={this.props.isEventDisabled? this.props.isEventDisabled(assignable_event): false} onChange={onChange} />
        </td>
      </tr>
    );
  }

  renderEmptyState() {
    if (this.props.events.length > 0) {
      return null;
    }

    return (
      <div className={`long-tr center ${this.props.emptyMessageBackgroundColorClass}`}>
        <div className="long-td">
          {this.props.emptyMessage}
        </div>
      </div>
    );
  }
}

export default AssignableEventsTable;
